import { Slider } from "@material-ui/core"
import { withStyles } from '@material-ui/styles'

export const StyledSlider = withStyles({
  root: {
    color: '#000',
    height: 2,
    padding: '15px 0',
  },
  thumb: {
    height: '1rem',
    width: '0.2rem',
    backgroundColor: '#000',
    borderRadius:0,
    marginTop: '-0.5rem',
    marginLeft: '-0.1rem',
    // boxShadow: BoxShadowActive,
    '&:focus, &:hover, &$active': {
      // boxShadow: BoxShadowInactive,
      '@media (hover: none)': {
        // boxShadow: BoxShadowActive,
      },
    },
  },
  active: {},
  track: {
    height: 1.5,
  },
  rail: {
    height: 1.5,
    opacity: 0.5,
    backgroundColor: '#666',
  },
  mark: {
    backgroundColor: '#666',
    height: 0,
    width: 0,
    marginTop: 0,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'currentColor',
  },
})(Slider);

export const StyledSliderDark = withStyles({
  root: {
    color: '#fff',
    height: 2,
    padding: '15px 0',
  },
  thumb: {
    height: '1rem',
    width: '0.2rem',
    backgroundColor: '#fff',
    borderRadius:0,
    marginTop: '-0.5rem',
    marginLeft: '-0.1rem',
    // boxShadow: BoxShadowActive,
    '&:focus, &:hover, &$active': {
      // boxShadow: BoxShadowInactive,
      '@media (hover: none)': {
        // boxShadow: BoxShadowActive,
      },
    },
  },
  active: {},
  track: {
    height: 1.5,
  },
  rail: {
    height: 1.5,
    opacity: 0.5,
    backgroundColor: '#ccc',
  },
  mark: {
    backgroundColor: '#ccc',
    height: 0,
    width: 0,
    marginTop: 0,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'currentColor',
  },
})(Slider);